import {ColumnRecord, ColumnTypes} from '@ui/NewTable/types';
import {LibraryBooksOutlined} from '@mui/icons-material';
import {IconButton} from '@mui/material';
import {TechnicalSupportTablePriorityCell} from './TechnicalSupportTablePriorityCell';
import {TechnicalSupportTableStatusCell} from './TechnicalSupportTableStatusCell';

type formateTechnicalSupportTableColumnsProps = {
    columns: ColumnRecord;
    setSelectedItemId: (data: string) => void;
};

export const formateTechnicalSupportTableColumns = ({
    columns,
    setSelectedItemId,
}: formateTechnicalSupportTableColumnsProps) => {
    const firstColumn: ColumnRecord = {
        first: {
            id: 'first',
            title: '',
            type: ColumnTypes.STRING,
            withoutSort: true,
            width: 58,
            customDisplayFormat: (rowId: any) => {
                return (
                    <IconButton
                        onClick={(event: any) => {
                            event.stopPropagation();
                            setSelectedItemId(rowId);
                        }}
                        color='inherit'
                    >
                        <LibraryBooksOutlined color='primary' />
                    </IconButton>
                );
            },
        },
    };
    const processedColumns = {...firstColumn, ...columns};

    delete processedColumns.files;

    if (processedColumns.priority) {
        processedColumns.priority.customDisplayFormat = TechnicalSupportTablePriorityCell;
    }

    if (processedColumns.lastStatus) {
        processedColumns.lastStatus.customDisplayFormat = TechnicalSupportTableStatusCell;
    }

    return processedColumns;
};
